import {equal as shallowEqual} from 'fast-shallow-equal';

import {StoreProvider} from '@lib/store/StoreProvider';
import {Selector} from '@lib/store/utils';

/**
 * 簡単なメモ化機能付き
 */
export const observeStore = <TSelector extends Selector>(
  selector: TSelector,
  store: StoreProvider,
  initialState: ReturnType<TSelector>,
  onChange: (val: ReturnType<TSelector>) => void,
  options?: {
    equalityFn?: Function;
  },
) => {
  const {equalityFn = shallowEqual} = options || {};
  let currentState = initialState;

  // let currentState: any;

  function handleChange() {
    let nextState = selector(store.getState()) as ReturnType<TSelector>;
    const same = equalityFn(nextState, currentState);
    if (!same) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  let unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
};

// export const observeStore = <TSelector extends Selector>(
//   selector: TSelector,
//   redux: ReduxState,
//   initialState: ReturnType<TSelector>,
//   onChange: (val: ReturnType<TSelector>) => void,
//   options?: {
//     equalityFn?: Function;
//   },
// ) => {
//   const {equalityFn = shallowEqual} = options || {};
//   let currentState = initialState;
//
//   // let currentState: any;
//
//   function handleChange() {
//     let nextState = selector(redux.getState()) as ReturnType<TSelector>;
//     const same = equalityFn(nextState, currentState);
//     if (!same) {
//       currentState = nextState;
//       onChange(currentState);
//     }
//   }
//
//   let unsubscribe = redux.subscribe(handleChange);
//   handleChange();
//   return unsubscribe;
// };
/**
 * ShanordComponentにするデコ-レーター
 * 全ページで共通のコンポーネント
 * ページ遷移してもunmount / destroyされないコンポーネント
 */
export function sharedComponent<T extends {new (...args: any[]): {}}>(
  constructor: T,
) {
  return class extends constructor {
    static isShared = true;
    protected _isShared: boolean;

    constructor(...args: any[]) {
      super(...args);
      this._isShared = true;
    }
  };
}

export const debounce = <T extends (...args: any[]) => unknown>(
  callback: T,
  delay = 250,
): ((...args: Parameters<T>) => void) => {
  let timeoutId: number; // Node.jsの場合はNodeJS.Timeout型にする
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => callback(...args), delay);
  };
};
